import { Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, title, description, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className="text-xs uppercase tracking-[0.35em] text-[#C9A55C] mb-5" data-testid="section-eyebrow">
        {eyebrow}
      </p>
    )}
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-[#F3EEE5]">
      {title}
    </h2>
    {description && <p className="mt-5 text-[#A9ABB2] leading-relaxed text-sm sm:text-base">{description}</p>}
  </Reveal>
);
